import {useEffect} from 'react'

import {isAddTraceEventEmitterProps, isClearTracesEventEmitterProps} from './helpers'
import traceEventEmitter from './traceEventEmitter'
import {useTraceContext} from './TraceProvider'

import type {PluginController} from '../type'
import type {TraceEventEmitterProps} from './type'

const TraceEventEmitterController: PluginController = () => {
    const {addTrace, clearTraces} = useTraceContext()

    useEffect(() => {
        const eventCallback = (props: TraceEventEmitterProps) => {
            if (isAddTraceEventEmitterProps(props)) {
                addTrace(props)
            }
            if (isClearTracesEventEmitterProps(props)) {
                clearTraces()
            }
        }

        traceEventEmitter.addEventListener(eventCallback)
        return () => {
            traceEventEmitter.removeEventListener(eventCallback)
        }
    }, [addTrace, clearTraces])

    return null
}

export default TraceEventEmitterController
